(function (appComponents) {

	// move to proto
	var savedOrdersView = function (parent) {
		var view = {
			_helpers: parent._helpers,
			_b2bUnit: parent._b2bUnit,
			_orders: parent._orders,
			_templates: parent.templates,
			_modals: parent._modals,
			_messages: parent._messages,
			_utils: parent._utils,
			context: Object.create(parent.context),
			parent: parent
		};

		view.name = "savedOrders";

		view.currentTabView = "list";

		view.savedQueryData = null;

		view.pager = view._helpers.getPager(view);

		view.opts = {
			numToDisplay: 12
		};

		view.context.pagerData = view.pager.data;

		view.elements = {
			get savedResultsNum() {
				return $('[pc-container="orders--saved-results-number"]');
			},
			get savedOrdersResults() {
				return $('[pc-container="orders--saved-orders-results"]');
			}
		};

		view.prepareSearchData = function () {
			var searchData = view.parent._queryData;

			if (searchData.view != view.name) {
				// initial search data
				searchData = {};
				searchData.view = view.name;
				searchData.resultsPerPage = view.opts.numToDisplay;
				searchData.pageNumber = 1;
				searchData.unit = view._b2bUnit.currentUnit.uid;

				if (view.parent.currentView == view.name) {
					view.parent._updateUrlQuery("replace", searchData);
				}
			}
			view.savedQueryData = searchData;

			return $.extend(true, {}, searchData);
		};

		view.parseGetOrdersResponse = function (data) {
			view.pager.data = data.pagination;
			view.context.orders = data.results;
			view.context.pagerData = view.pager.data;
		};

		view.checkTabView = function () {
			if (view.currentTabView == "list") {
				view.context.listTabActiveClass = "active";
				view.context.gridTabActiveClass = "";
				$("#list_order").addClass("active");
				$("#grid_order").removeClass("active");
			} else if (view.currentTabView == "grid") {
				view.context.listTabActiveClass = "";
				view.context.gridTabActiveClass = "active";
				$("#grid_order").addClass("active");
				$("#list_order").removeClass("active");
			}
		};

		view.renderSavedResults = function (ignoreAnim) {
			view.checkTabView();

			view.renderSavedOrders(ignoreAnim);
			view.updateSavedResultsNum();
		};

		view.renderSavedOrders = function (ignoreAnim) {
			var html = view._templates.savedOrdersResults(view.context);
			if (ignoreAnim) {
				view.elements.savedOrdersResults.html(html);
			} else {
				view.elements.savedOrdersResults.hide().html(html).fadeIn("fast");
			}
		};

		view.updateSavedResultsNum = function () {
			view.elements.savedResultsNum.text(view.pager.data.totalNumberOfResults);
		};

		view.searchOrdersWithPager = function (ignoreAnim) {
			var searchData = view.prepareSearchData();

			view._orders.getSavedOrders(searchData).then(function (data) {
				if (data && data.results) {
					view.parseGetOrdersResponse(data);
					view.renderSavedResults(ignoreAnim);
				}
			});
		};

		view.updateQueryRoutine = function (searchData) {
			if (!searchData) {
				searchData = view.parent._queryData;
			}

			var pagerData = {
				pageNumber: view.pager.pageToSet,
				resultsPerPage: view.pager.pageSize
			};

			var queryData = jQuery.extend({}, searchData, pagerData);

			queryData.view = view.name;

			view.savedQueryData = queryData;

			view.parent._updateUrlQuery("push", queryData);

		};

		view.handlers = {
			onSetTabView: function (type) {
				view.currentTabView = type;
			},
			pager: {
				onPagerClick: function () {
					view.updateQueryRoutine();
					view.searchOrdersWithPager("ignoreAnim");
				}
			}
		};

		view.init = function () {

			if (view.savedQueryData) {
				view.parent._updateUrlQuery("push", view.savedQueryData);
			}

			view.pager.init();
		};

		return view;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.ordersOverview == null) appComponents.pageComponents.ordersOverview = {};
	appComponents.pageComponents.ordersOverview.savedOrdersView = savedOrdersView;

	window.appComponents = appComponents;

})(window.appComponents || {});